"use strict";
/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAPIMappers = exports.SearchAPIModels = exports.SearchAPIContext = exports.SearchAPI = void 0;
var msRest = require("@azure/ms-rest-js");
var Models = require("./models");
exports.SearchAPIModels = Models;
var Mappers = require("./models/mappers");
exports.SearchAPIMappers = Mappers;
var Parameters = require("./models/parameters");
var searchAPIContext_1 = require("./searchAPIContext");
Object.defineProperty(exports, "SearchAPIContext", { enumerable: true, get: function () { return searchAPIContext_1.SearchAPIContext; } });
var SearchAPI = /** @class */ (function (_super) {
    __extends(SearchAPI, _super);
    /**
     * Initializes a new instance of the SearchAPI class.
     * @param [options] The parameter options
     */
    function SearchAPI(options) {
        return _super.call(this, options) || this;
    }
    SearchAPI.prototype.azureSearch = function (genericSearchRequestJson, options, callback) {
        return this.sendOperationRequest({
            genericSearchRequestJson: genericSearchRequestJson,
            options: options
        }, azureSearchOperationSpec, callback);
    };
    SearchAPI.prototype.azureAutocomplete = function (genericAutocompleteRequestJson, options, callback) {
        return this.sendOperationRequest({
            genericAutocompleteRequestJson: genericAutocompleteRequestJson,
            options: options
        }, azureAutocompleteOperationSpec, callback);
    };
    SearchAPI.prototype.recreateAzureSearchIndex = function (body, options, callback) {
        return this.sendOperationRequest({
            body: body,
            options: options
        }, recreateAzureSearchIndexOperationSpec, callback);
    };
    return SearchAPI;
}(searchAPIContext_1.SearchAPIContext));
exports.SearchAPI = SearchAPI;
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var azureSearchOperationSpec = {
    httpMethod: "GET",
    path: "adapters/azure/search",
    queryParameters: [
        Parameters.genericSearchRequestJson
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GenericSearchResponse
        },
        400: {},
        500: {},
        default: {}
    },
    serializer: serializer
};
var azureAutocompleteOperationSpec = {
    httpMethod: "GET",
    path: "adapters/azure/autocomplete",
    queryParameters: [
        Parameters.genericAutocompleteRequestJson
    ],
    responses: {
        200: {
            bodyMapper: Mappers.GenericAutocompleteResponse
        },
        400: {},
        500: {},
        default: {}
    },
    serializer: serializer
};
var recreateAzureSearchIndexOperationSpec = {
    httpMethod: "POST",
    path: "indexers/azure/recreate",
    requestBody: {
        parameterPath: "body",
        mapper: __assign(__assign({}, Mappers.IndexerRequest), { required: true })
    },
    responses: {
        200: {},
        500: {},
        default: {}
    },
    serializer: serializer
};
